import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { activities } from '../../data/site';
export function Activites() {
  const [featured, ...others] = activities;
  return <section id="activites" className="scroll-mt-24 bg-grege py-20 md:py-24" data-id="element-79" data-mp="zbmwjup9ppyk">
      <div className="mx-auto max-w-7xl px-6" data-id="element-80" data-mp="ud1xhylr5cbp">
        <div className="max-w-2xl" data-id="element-81" data-mp="ued8aidm7kcb">
          <h2 className="font-display text-3xl font-bold text-nuit sm:text-4xl" data-id="element-82" data-mp="6nr0ms7iw22u">
            Cinq façons de nous rejoindre
          </h2>
          <p className="mt-3 text-nuit/70" data-id="element-83" data-mp="1q7nxwqh3xd0">
            Aucune expérience requise, aucune audition : on vient essayer une séance, et on voit.
          </p>
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-[1.1fr_1fr]" data-id="element-84" data-mp="bmkfop2gk154">
          <Link to={featured.href} className="group relative flex min-h-[26rem] flex-col justify-end overflow-hidden rounded-3xl bg-nuit p-8 text-creme" data-id="element-85" data-mp="bpge0ei7wru3">
            {featured.image && <img src={featured.image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-60 transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-86" data-mp="1cisqfzco1e1i" />}
            <div className="absolute inset-0 bg-nuit/70" data-id="element-87" data-mp="1meckeg7o62nm" />
            <div className="relative" data-id="element-88" data-mp="1qh0ussc17hmp">
              <span className="inline-block rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-[0.14em] text-white" style={{
              backgroundColor: featured.color === '#0F1E2E' ? '#E76E31' : featured.color
            }} data-id="element-89" data-mp="1qfy4ommj9j7u">
                {featured.tagline}
              </span>
              <h3 className="mt-4 font-display text-3xl font-bold" data-id="element-90" data-mp="17j6cfnp0jtrn">{featured.name}</h3>
              <p className="mt-3 max-w-md text-creme/80" data-id="element-91" data-mp="17l0zp8nrbxyw">{featured.description}</p>
              <p className="mt-5 text-sm font-semibold text-soleil" data-id="element-92" data-mp="b11rpvh9ubtb">{featured.rhythm}</p>
            </div>
          </Link>

          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-93" data-mp="f0izwwo31n26">
            {others.map(activity => <li key={activity.slug} className="flex" data-id="element-94" data-mp="1ibgb6vtwboxx">
                <Link to={activity.href} className="group flex w-full flex-col rounded-3xl bg-creme p-6 transition-transform duration-200 ease-out hover:-translate-y-1" data-id="element-95" data-mp="1ddwuzqdn123c">
                  <span className="h-10 w-10 rounded-full" style={{
                backgroundColor: activity.color
              }} aria-hidden="true" data-id="element-96" data-mp="1n5az6bgjaq2t" />
                  <h3 className="mt-5 font-display text-xl font-semibold text-nuit" data-id="element-97" data-mp="uhyfc91rcwd7">
                    {activity.name}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-nuit/70" data-id="element-98" data-mp="14di84ml0zexq">
                    {activity.description}
                  </p>
                  <div className="mt-auto pt-5" data-id="element-99" data-mp="2jt7cn7god59t">
                    <p className="text-sm font-semibold text-nuit/80" data-id="element-100" data-mp="2ftgkazbi2h36">{activity.rhythm}</p>
                    <span className="mt-2 inline-flex items-center gap-1.5 text-sm font-semibold text-braise" data-id="element-101" data-mp="2nczc9v2q1knw">
                      Découvrir
                      <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-102" data-mp="2sckb85hw5t0m" />
                    </span>
                  </div>
                </Link>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}